<template>
   <div v-if="loading" class="text-center text-gray-600 text-default my-4">
    <b-spinner class="align-middle"></b-spinner>
    <strong> Verificando regras não aplicáveis ...</strong>
  </div>
  <div v-else class="customer-rules-wrapper p-3">
    <rule
      v-for="rule in rules"
      :rule="rule"
      :key="rule.id"
      isNotApplicable
    />
    <div v-if="!rules.length && !loading">
      Não há regras não aplicáveis.
    </div>
    <!-- <fields-checklist v-if="!rules.length" :form=customer /> -->
  </div>
</template>

<script>
import TextInfo from '@/components/TextInfo.vue';
import Rule from '@/components/Rule.vue';
import { getNotApplicableRules } from '@/services/customers';
import FieldsChecklist from './FieldsChecklist.vue';
import moment from 'moment';

export default {
  name: 'RulesNotApplicable',
  components: { TextInfo, Rule, FieldsChecklist },
  props: {
    notApplicableRules: {
      type: Array,
      default: () => []
    },
    loadingRules: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.rules = this.notApplicableRules;
    // if (!this.notApplicableRules.length) {
    //   this.getNotApplicableRules();
    // } else {
    //   this.rules = this.notApplicableRules;
    // }
  },
  data() {
    return {
      rules: [],
      customer: null,
      calculation: null,
      loading: false,
    }
  },
  watch: {
    notApplicableRules: {
      handler(newRules) {
        if (newRules) {
          this.rules = newRules;
        }
      },
      immediate: true
    },
    loadingRules: {
      handler(newValue) {
        this.loading = newValue;
      },
      immediate: true
    }
  },
  methods: {
    async getNotApplicableRules() {
      this.loading = true;

      const { rules, customer, calculation } = await getNotApplicableRules(this.$route.params.calculationId);
      const publicServiceIngressDate = moment(calculation.publicServiceIngressDate);

      if (calculation.regimeType === 'RPPSV2') {
        this.rules = rules;
      } else {
        this.rules = rules.filter((rule) => {
          return (publicServiceIngressDate.year() <= rule.ruleYear && !this.isFutureRule(rule));
        });
      }

      this.customer = customer;
      this.calculation = calculation;

      this.loading = false;
    },
    isFutureRule(rule) {
      if (rule.ruleYear >= 2019) {
        const necessaryAge = rule.decreasedNecessaryAge || rule.necessaryAge || 0;
        const currentAge = this.currentAge(rule);
        if (currentAge < necessaryAge) {
          return moment(rule?.customer?.birthDate).add(necessaryAge, 'years').format('DD/MM/YYYY');
        }
      }
      return false;
    },
    currentAge(rule) {
      return this.lawDate(rule).diff(moment(rule.customer?.birthDate), 'years');
    },
    lawDate(rule) {
      return rule.ruleYear === 2019 ? moment() : moment(rule.ruleLimitDate);
    },
  }
}
</script>

<style scoped>
</style>
